import HeaderNone from './../../components/component/header/header_none.jsx';

// import AboutUSComponent from './../../components/component/about_us_components/about_us.jsx';


import FooterNone from './../../components/component/footer/footer_none.jsx'
import LaptopFooter from './../../components/component/footer/laptop_footer.jsx';



function CrewMembers() {
    return (
            <main>
                <HeaderNone />
                {/* <AboutUSComponent /> */}

                <FooterNone />
                <LaptopFooter />

            </main>
    );
}

export default CrewMembers;

